import axios from "axios";
import { API_URL } from "@/config";

const base = `${API_URL}/warranty`;

// ─── Auth ─────────────────────────────────────────────────────────────────
export const loginWarranty     = (email: string, password: string) =>
    axios.post(`${base}/auth/login`, { email, password }, { withCredentials: true });

export const logoutWarranty    = () =>
    axios.post(`${base}/auth/logout`, {}, { withCredentials: true });

export const getCurrentWarranty = () =>
    axios.get(`${base}/auth/me`, { withCredentials: true });

export const listWarrantyCompaniesPublic = () =>
    axios.get(`${base}/companies/list`);

// ─── Customer ─────────────────────────────────────────────────────────────
export const createWarrantyRequest = (data: {
    deal_id?: number; credit_app_id?: number; vehicle_vin?: string;
    vehicle_year?: number; vehicle_make?: string; vehicle_model?: string;
    vehicle_type?: string; mileage?: string; notes?: string;
}) => axios.post(`${base}/requests`, data, { withCredentials: true });

export const getMyWarrantyRequests = () =>
    axios.get(`${base}/my-requests`, { withCredentials: true });

export const getMyWarrantyQuotesForDeal = (dealId: number) =>
    axios.get(`${base}/my-quotes/deal/${dealId}`, { withCredentials: true });

export const acceptWarrantyQuote = (quoteId: number) =>
    axios.patch(`${base}/quotes/${quoteId}/accept`, {}, { withCredentials: true });

// ─── Warranty company ─────────────────────────────────────────────────────
export const listWarrantyLeads = () =>
    axios.get(`${base}/quote-requests`, { withCredentials: true });

export const accessWarrantyLead = (requestId: number) =>
    axios.post(`${base}/quote-requests/${requestId}/access`, {}, { withCredentials: true });

export const submitWarrantyQuote = (requestId: number, data: {
    deal_id?: number; customer_id?: number; coverage_type?: string;
    coverage_months?: number; coverage_miles?: string; deductible?: string;
    monthly_cost?: string; total_cost?: string; notes?: string;
}) => axios.post(`${base}/quote-requests/${requestId}/quote`, data, { withCredentials: true });

export const uploadWarrantyContract = (quoteId: number, formData: FormData) =>
    axios.patch(`${base}/quotes/${quoteId}/contract`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
    });

export const getMySubmittedWarrantyQuotes = () =>
    axios.get(`${base}/my-submitted-quotes`, { withCredentials: true });

export const getWarrantyBilling = () =>
    axios.get(`${base}/billing`, { withCredentials: true });

// ─── Admin ────────────────────────────────────────────────────────────────
export const adminListWarrantyCompanies = () =>
    axios.get(`${API_URL}/admin/warranty/companies`, { withCredentials: true });

export const adminCreateWarrantyCompany = (data: {
    company_name: string; company_code: string; email: string; password: string;
    phone?: string; contact_name?: string; license_states?: string; license_number?: string;
    company_type?: string; vehicle_types_covered?: string[];
    lead_rate?: string; logo_url?: string; website?: string; notes?: string;
}) => axios.post(`${API_URL}/admin/warranty/companies`, data, { withCredentials: true });

export const adminUpdateWarrantyStatus = (id: number, status: string) =>
    axios.patch(`${API_URL}/admin/warranty/companies/${id}/status`, { status }, { withCredentials: true });
